module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [(_vm.dashboardFlags['evsensAdminFlag']) ? _c('div', {
    staticClass: "sidebar-l sidebar-o header-navbar-fixed",
    class: {
      'sidebar-o-xs': _vm.sidebarIsActive
    },
    attrs: {
      "id": "page-container"
    }
  }, [_c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebar-scroll"
    }
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "side-header side-content bg-white-op"
  }, [_c('button', {
    staticClass: "btn btn-link text-gray pull-right hidden-md hidden-lg",
    attrs: {
      "type": "button",
      "data-toggle": "layout",
      "data-action": "sidebar_close"
    },
    on: {
      "click": function($event) {
        return _vm.displaySidebar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('a', {
    staticClass: "h5 text-white"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w600 sidebar-mini-hide"
  }, [_vm._v(_vm._s(_vm.profileData.licences[0].licenceLabel[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.actualiserArborescence()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelRefresh[_vm.actualLanguage]) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goHomeGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home fa-2x pull-left"
  }), _c('font', {
    attrs: {
      "size": "3",
      "color": "white"
    }
  }, [_vm._v("Home")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [(_vm.flagArborescenceIsLoading == false) ? _c('ul', {
    staticClass: "nav-main"
  }, [_c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', {
    staticClass: "sidebar-mini-hide"
  }, [_c('font', {
    attrs: {
      "size": "3"
    }
  }, [_vm._v(_vm._s(_vm.menuLabelGroup[_vm.actualLanguage]))])], 1)]), _vm._v(" "), (_vm.flagGroupSelectedByBundle === false) ? _c('div', _vm._l((_vm.groupParentTempo), function(group, index) {
    return _c('div', [(group.sub_group.length) ? _c('div', [(_vm.flagGroupInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1), _vm._v(" "), (group.sub_group.length) ? _c('ul', _vm._l((group.sub_group), function(subGroup, index2) {
      return _c('div', [_c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.selectSecondLevelGroup(index2)
          }
        }
      }, [_vm._v(_vm._s(subGroup.group_name))])])])
    }), 0) : _vm._e()])]) : _c('div', [_c('li', [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1)])])]) : _c('div', [(_vm.flagGroupInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      staticClass: "active",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      staticClass: "active",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1)])]) : _c('div', [_c('li', [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1)])])])])
  }), 0) : _c('div', [_c('div', {
    staticClass: "block-content"
  }, [(_vm.flagPersonalGroupSelected) ? _c('button', {
    staticClass: "btn btn-block btn-default",
    staticStyle: {
      "white-space": "normal"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-2x pull-left"
  }), _c('font', {
    attrs: {
      "size": "2",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.actualGroup.group_name))])], 1) : _c('button', {
    staticClass: "btn btn-block btn-default",
    staticStyle: {
      "white-space": "normal"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-users fa-2x pull-left"
  }), _c('font', {
    attrs: {
      "size": "2",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.actualGroup.group_name))])], 1)])]), _vm._v(" "), (_vm.flagGroupSelected) ? _c('div', [_c('div', {
    staticClass: "block-content push-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content push-10"
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', {
    staticClass: "sidebar-mini-hide"
  }, [_c('font', {
    attrs: {
      "size": "3"
    }
  }, [_vm._v(_vm._s(_vm.menuLabelSystem[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _vm._l((_vm.bundleParentTempo.bundles), function(bundle, index) {
    return _c('div', [(bundle.sub_bundle.length) ? _c('div', [(_vm.flagBundleInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [_c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1), _vm._v(" "), (bundle.sub_bundle.length) ? _c('ul', _vm._l((bundle.sub_bundle), function(subBundle, index2) {
      return _c('div', [_c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.selectSecondLevelBundle(index2)
          }
        }
      }, [_vm._v(_vm._s(subBundle.ReferenceName))])])])
    }), 0) : _vm._e()])]) : _c('div', [_c('li', [_c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1)])])]) : _c('div', [(_vm.flagBundleInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [_c('a', {
      staticClass: "active",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1)])]) : _c('div', [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1)])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content push-10"
  }), _vm._v(" "), (_vm.flagGroupSelectedByBundle) ? _c('div', {
    staticClass: "block-content"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSelectedBundle()
      }
    }
  }, [(_vm.flagBundleIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-cloud-download pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelReadSystem[_vm.actualLanguage]))])], 1)]) : _vm._e()], 2) : _vm._e()]) : _c('spinner')], 1)])])]), _vm._v(" "), _c('header', {
    staticClass: "content-mini content-mini-full",
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed"
  }, [_c('ul', {
    staticClass: "nav-header pull-left"
  }, [_c('li', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "layout",
      "data-action": "sidebar_toggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.displaySidebar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.displayElIot) ? _c('li', {
    staticClass: "h1 header-content"
  }, [_c('h1', [_vm._v("EL-iot")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav-header pull-right"
  }, [(_vm.mobile == false && _vm.displayElIot) ? _c('li', [_c('h3', {
    staticClass: "h3 block-title"
  }, [_vm._v(_vm._s(_vm.messageAcceuil[_vm.actualLanguage]) + " " + _vm._s(_vm.profileData.profileInfo.firstName) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.displayHeadMenuShowHideButton && _vm.mobile == false) ? _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleShowHideHead()
      }
    }
  }, [(_vm.displayHeadMenu) ? _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.displayHideHeadMenuClose[_vm.actualLanguage]))]) : _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.displayHideHeadMenuOpen[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLanguage()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "si si-settings"
  }), _vm._v(" " + _vm._s(_vm.actualLanguage))])])]) : _c('li', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLanguage()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.actualLanguage))])])]), _vm._v(" "), (_vm.mobile == false) ? _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "si si-power"
  })])]) : _c('li', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "35px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "si si-power"
  })])])])])]), _vm._v(" "), (_vm.displayHeadMenu) ? _c('div', {
    staticClass: "row"
  }, [(_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('hr'), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb push-10-t"
  }, [_c('li', [_c('a', {
    staticClass: "link-effect",
    on: {
      "click": function($event) {
        return _vm.goHomeGroup()
      }
    }
  }, [_c('font', {
    attrs: {
      "size": "3"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Home")])], 1)]), _vm._v(" "), _vm._l((_vm.navBarLink), function(navItem, index) {
    return _c('li', [_c('a', {
      staticClass: "link-effect",
      on: {
        "click": function($event) {
          return _vm.goBackNav(index)
        }
      }
    }, [(navItem.Type === 'GU') ? _c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }) : _vm._e(), (navItem.Type === 'GS') ? _c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }) : _vm._e(), _c('font', {
      attrs: {
        "size": "3"
      }
    }, [_vm._v(_vm._s(navItem.Name))])], 1)])
  })], 2), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.flagGroupSelected) ? _c('div', [(_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('h3', [(_vm.flagPersonalGroupSelected == false) ? _c('i', {
    staticClass: "fa fa-industry push-5-r"
  }) : _vm._e(), _vm._v(_vm._s(_vm.actualGroup.rightsProviderName) + "\n            ")]), _vm._v(" "), _c('hr')]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.flagBundleIsLoaded) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-darker navbar-collapse remove-padding collapse",
    attrs: {
      "id": "sub-header-nav"
    }
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sub-header push"
  }, [(false) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 1
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelProfileButton[_vm.actualLanguage]) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length && _vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 2
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'ports'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-car push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelPortButton[_vm.actualLanguage]) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 3
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'measurements'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelMesElcButton[_vm.actualLanguage]) + "\n                    ")])], 1), _vm._v(" "), (_vm.flagDisplayCostSplittingMenu) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 4
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'cost-splitting'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelSplitCostButton[_vm.actualLanguage]) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 5
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'configuration'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders push-5-r"
  }), _vm._v(" Configuration\n                    ")])], 1), _vm._v(" "), (_vm.profileData.sharingInvitations.length > 0) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 6
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'sharing'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt push-5-r fa-1x"
  }), _vm._v(" " + _vm._s(_vm.labelSharingButton[_vm.actualLanguage]) + " "), _c('i', {
    staticClass: "fa fa-exclamation-circle push-5-r fa-1x"
  })])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 7
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'help'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelHelpButton[_vm.actualLanguage]) + "\n                    ")])], 1), _vm._v(" "), (_vm.dashboardFlags.evsensMasterFlag) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 8
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'evsensadmin'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-server push-5-r"
  }), _vm._v(" EV Sens Admin\n                    ")])], 1) : _vm._e()])])])])])]) : _vm._e()])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), (_vm.flagBundleIsLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 align-center push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.messageLoading[_vm.actualLanguage]))]), _vm._v(" "), _c('spinner')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.flagBundleIsLoaded) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [(_vm.mobile) ? _c('div', [(_vm.headerMenuSelectedTab == 3 || _vm.headerMenuSelectedTab == 4) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSelectedBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download pull-left"
  }), _c('i', {
    staticClass: "fa fa-refresh pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelReadRefreshSystem[_vm.actualLanguage]) + "\n                ")])]) : _vm._e()]) : _c('div', [(_vm.headerMenuSelectedTab == 3 || _vm.headerMenuSelectedTab == 4) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSelectedBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download pull-left"
  }), _c('i', {
    staticClass: "fa fa-refresh pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelReadRefreshSystem[_vm.actualLanguage]) + " : " + _vm._s(_vm.bundleTempo.bundle_name) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('router-view')], 1)]) : _c('div', [(_vm.flagDisplayHome) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.displayHomeTab) ? _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuProfile[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-industry"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuOrganizations[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuFirstLevelGroup[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuResearch[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[4] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(4)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuHelp[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[0] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('profile-view')], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[1] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.profileData.managed_organizations.length > 0) ? _c('div', [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelOrganization[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.profileData.managed_organizations), function(organization, index) {
    return _c('div', [_c('organization-display', {
      attrs: {
        "organizationIndex": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button",
      "data-toggle": "popover",
      "title": this.massageOrganizationRequired[this.actualLanguage]
    },
    on: {
      "click": function($event) {
        return _vm.showModal('organization-add-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-industry fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateOrganization[_vm.actualLanguage]))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openMultiGroupDocumentation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-1x push-10-r "
  }), _vm._v(_vm._s(_vm.buttonHelpManagerVersionDocumentation[_vm.actualLanguage]))])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[2] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.userAcessLevel2Flag && _vm.profileData.managed_organizations.length > 0 && _vm.mobile == false) ? _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textLabelCreateFirstLevelGroup[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v(_vm._s(_vm.textIndicationCreateFirstLevelGroup[_vm.actualLanguage]) + " :  " + _vm._s(_vm.profileData.managed_organizations[_vm.actualOrganizationIndex].organizationName))])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelSelectGroup[_vm.actualLanguage]) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualOrganizationIndex),
      expression: "actualOrganizationIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualOrganizationIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.profileData.managed_organizations), function(organization, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                                              " + _vm._s(organization.organizationName) + "\n                                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewGroupInOrganization()
      }
    }
  }, [(_vm.groupInOrganizationIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-users fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateFirstLevelGroup[_vm.actualLanguage]))])], 1)])])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[3] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "content content-boxed push"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.findElementSectionLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stringToFind),
      expression: "stringToFind"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Rechercher/Search"
    },
    domProps: {
      "value": (_vm.stringToFind)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.researchInProfile()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stringToFind = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.researchInProfile()
      }
    }
  }, [(_vm.researchInProgress) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('i', {
    staticClass: "fa fa-search"
  })], 1)])])]), _vm._v(" "), (_vm.searchDoneFlag) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.researchResults.length > 0) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleType[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitlePath[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleRefName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleAction[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.researchResults), function(findItem, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center-bold"
    }, [(findItem.EntityType === 'Channel') ? _c('i', {
      staticClass: "fa fa-television fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Device') ? _c('i', {
      staticClass: "fa fa-server fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Bundle') ? _c('i', {
      staticClass: "fa fa-usb fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Group') ? _c('i', {
      staticClass: "fa fa-users fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Car') ? _c('i', {
      staticClass: "fa fa-car fa-2x push-5-r "
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      on: {
        "click": function($event) {
          return _vm.researchResultGoToPath(index)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(findItem.EntityPath))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(findItem.EntityName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(findItem.EntityReferenceName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Aller à/ Go to"
      },
      on: {
        "click": function($event) {
          return _vm.researchResultGoToPath(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-folder-open"
    })])])])
  }), 0)])])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.findElementNoResults[_vm.actualLanguage]))])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[4] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('help-section')], 1)])])]) : _vm._e()])])]), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', {
    staticClass: "row push"
  }, _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', {
      staticClass: "row push"
    }, [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Group') ? _c('div', {
      staticClass: "col-sm-12"
    }, [(_vm.groupConfigEditFlag) ? _c('div', {
      staticClass: "content content-boxed"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textYouReceiveGroupSharing[_vm.actualLanguage]))]), _vm._v(" "), _c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1)]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "col-sm-12 push-50"
  }), _vm._v(" "), (_vm.flagBundleSelected === false) ? _c('div', [(_vm.groupConfigViewFlag && _vm.flagPersonalGroupSelected == false) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h2', {
    staticClass: "font-w300 push-30"
  }, [_vm._v(_vm._s(_vm.textIndicationSelectAddGroupOrSystem[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textIndicationAddOrModifyGroup[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-group fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.actualGroup.group_name))])])]), _vm._v(" "), (_vm.flagShowCustomerSupportSection) ? _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_vm._m(3), _vm._v(" "), (_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-lg-12 push"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewUserProfile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-user fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v("Create customer profile for pre-configuration")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 push"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addDefaultBundleOfExistingUser()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v("Add an existing customer profile bundle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 push"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeSpecifiedSystem()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v("Remove specific system from this group")])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelAddComponentToGroupe[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewGroupInGroup()
      }
    }
  }, [(_vm.groupInGroupIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-users fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddSubGroup[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewBundleInGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddSystemToGroup[_vm.actualLanguage]) + " ")])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row push"
  }, [(_vm.groupSharingEnableFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareActualGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareThisGroup[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.groupConfigDeleteFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteActualGroup()
      }
    }
  }, [(_vm.groupIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteGroup[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-sliders fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelConfigGroup[_vm.actualLanguage]))])]), _vm._v(" "), _c('config-group')], 1)])]), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', {
    staticClass: "row push"
  }, _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', {
      staticClass: "row push"
    }, [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Group') ? _c('div', {
      staticClass: "col-sm-12"
    }, [(_vm.groupConfigEditFlag) ? _c('div', {
      staticClass: "content content-boxed"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textYouReceiveGroupSharing[_vm.actualLanguage]))]), _vm._v(" "), _c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1)]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', {
    staticClass: "row push"
  }, _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', {
      staticClass: "row push"
    }, [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Bundle') ? _c('div', {
      staticClass: "col-sm-12"
    }, [(_vm.groupConfigEditFlag) ? _c('div', {
      staticClass: "content content-boxed"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textYouReceiveSystemSharing[_vm.actualLanguage]))]), _vm._v(" "), _c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1)]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textIndicationSelectGroupOrSystem[_vm.actualLanguage]))])])])])])]) : _c('div', {
    staticClass: "content content-boxed"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textMessageSelectAndPressReadSystem[_vm.actualLanguage]))])])])])])])]), _vm._v(" "), _vm._m(7)]) : _c('div', {
    staticClass: "sidebar-l side-scroll header-navbar-fixed",
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "page-container"
    }
  }, [_c('header', {
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed"
  }, [_vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "nav-header pull-right"
  }, [(_vm.mobile == false) ? _c('li', [_c('h3', {
    staticClass: "h3 block-title"
  }, [_vm._v(_vm._s(_vm.messageAcceuil[_vm.actualLanguage]) + " " + _vm._s(_vm.profileData.profileInfo.firstName) + " ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLanguage()
      }
    }
  }, [_c('i', {
    staticClass: "si si-settings"
  }), _vm._v(" " + _vm._s(_vm.actualLanguage) + "\n              ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "si si-power"
  })])])])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-darker navbar-collapse remove-padding collapse",
    attrs: {
      "id": "sub-header-nav"
    }
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sub-header push"
  }, [_c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelProfileButton[_vm.actualLanguage]) + "\n                ")])], 1), _vm._v(" "), (_vm.profileData.rights.rights.dashboardEvLogFlag && _vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'ports'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-car push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelPortButton[_vm.actualLanguage]) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'measurements'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flash push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelMesElcButton[_vm.actualLanguage]) + "\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'configuration'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders push-5-r"
  }), _vm._v(" Configuration\n                ")])], 1), _vm._v(" "), (_vm.profileData.sharingInvitations.length > 0) ? _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'sharing'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt push-5-r fa-1x"
  }), _vm._v(" " + _vm._s(_vm.labelSharingButton[_vm.actualLanguage]) + " "), _c('i', {
    staticClass: "fa fa-exclamation-circle push-5-r fa-1x"
  })])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'help'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelHelpButton[_vm.actualLanguage]) + "\n                ")])], 1), _vm._v(" "), (_vm.dashboardFlags.evsensMasterFlag) ? _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'evsensadmin'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-server push-5-r"
  }), _vm._v(" EV Sens Admin\n                ")])], 1) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-container"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), (_vm.profileData.profileInfo.policyAgreement.agreeFlag) ? _c('div', [(_vm.profileDataReceivedFlag && _vm.flagBundleIsLoaded) ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticClass: "block-content"
  }, [(_vm.flagBundleIsLoading == false) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelSession[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success btn-lg push-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelSessionBtn[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })]) : _c('div', {
    staticClass: "col-md-12 align-center push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.messageLoading[_vm.actualLanguage]))]), _vm._v(" "), _c('spinner')], 1)])]) : _c('div', {
    staticClass: "block-content"
  }, [_c('policy-agreement')], 1)]), _vm._v(" "), _vm._m(11)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header-content"
  }, [_c('a', {
    staticClass: "h4 main-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/evsens-logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-lighter visible-xs"
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('button', {
    staticClass: "btn btn-block btn-default visible-xs push collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#sub-header-nav",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon push-5-r"
  }), _vm._v("Menu\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-user fa-1x push-5-r "
  }), _vm._v("EV Sens Customer support")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v("Use this button to create a non existing user profile and add its system in this group.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v("Use this button to add the default system of an existing user profile email. Note the added system will have a generic name. Don't add two generic name system at same time in the group.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v("Use this button to remove a specific system from this group.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "content-mini content-mini-full font-s12 bg-gray-lighter clearfix",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "https://evsens.ca",
      "target": "_blank"
    }
  }, [_vm._v("EV Sens ")]), _vm._v(" © "), _c('span', {
    staticClass: "js-year-copy"
  }, [_vm._v("2020")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-header pull-left"
  }, [_c('li', {
    staticClass: "header-content"
  }, [_c('a', {
    staticClass: "h5 main-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/evsens-logo.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "header-content"
  }, [_c('h1', {
    staticClass: "h1 block-title"
  }, [_vm._v("EL-iot")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-lighter visible-xs"
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('button', {
    staticClass: "btn btn-block btn-default visible-xs push collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#sub-header-nav",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon push-5-r"
  }), _vm._v("Menu\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr'), _vm._v(" "), _c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "content-mini content-mini-full font-s12 bg-gray-lighter clearfix",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "https://evsens.ca",
      "target": "_blank"
    }
  }, [_vm._v("EV Sens ")]), _vm._v(" © "), _c('span', {
    staticClass: "js-year-copy"
  }, [_vm._v("2020")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-871c593a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Dashboard.vue
// module id = 1572
// module chunks = 4